module.exports = __webpack_public_path__ + "static/media/Wuhan.1fce77f3.jpg";